import React from 'react';
import localStorageAvailable from '@javascript/helpers/localStorage';
import classNames from 'classnames';

interface ContinueSearchButtonProps {
  page: string;
}

const ContinueSearchButton: React.FC<ContinueSearchButtonProps> = ({
  page,
}) => {
  const returnToSearch = () => {
    if (localStorageAvailable()) {
      return (
        localStorage
          .getItem('lastSearch')
          ?.replace('/stock-alerts/new', '/vehicles') || '/vehicles'
      );
    }
    return '/vehicles';
  };
  return (
    <a
      className={classNames('ch-btn db-submit--button', {
        'ch-btn--success': page !== 'failed',
      })}
      data-gtm-track="interaction"
      data-gtm-track-action="Reserve now journey"
      data-gtm-track-label="Continue search button"
      href={returnToSearch()}
    >
      {page === 'failed' ? 'Return to search' : 'Continue my search'}
    </a>
  );
};

export default ContinueSearchButton;
